import axios from 'axios';

const actions = {
  // eslint-disable-next-line
  login({}, credentials) {
    const url = `${process.env.VUE_APP_SERVER_URL}/login`;
    return axios.post(url, credentials)
      .then((response) => {
        const { token } = response.data;
        localStorage.setItem('token', token);
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      });
  },
  getUser({ commit }) {
    const url = `${process.env.VUE_APP_SERVER_URL}/user`;
    return axios.get(url)
      .then((response) => {
        const user = response.data;
        commit('setUser', user);
        return user;
      });
  },
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
};

const state = {
  user: {},
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
